import * as featuredService from './featured.service'

export const getFeaturedCampaigns = () => {
    return featuredService.getFeaturedCampaigns()
        .then(res => res.data)
        .then(data => data.hits.hits)
}